import {
  AppliedDiscountMeta,
  BurnToken,
  ModifiedDocumentMeta,
  SessionDocumentInfo,
} from '../models';

export function sortDocuments(
  documents: SessionDocumentInfo[],
  field?: string,
  order?: number,
) {
  return documents?.sort((d1, d2) => {
    if (field) {
      order = order ?? 1;
      const value1 = d1[field] as unknown;
      const value2 = d2[field] as unknown;
      // sort empty values
      if (value1 == null && value2 != null) return -1 * order;
      if (value1 != null && value2 == null) return 1 * order;
      // sort field values
      if (value1 < value2) return -1 * order;
      if (value1 > value2) return 1 * order;
    }
    // tie breaker 1: document date, oldest first
    const documentDate1 = +new Date(d1.documentDate ?? 0);
    const documentDate2 = +new Date(d2.documentDate ?? 0);
    if (documentDate1 < documentDate2) return -1;
    if (documentDate1 > documentDate2) return 1;
    // tie breaker 2: open balance, largest first
    const openBalance1 = d1.openBalance ?? 0;
    const openBalance2 = d2.openBalance ?? 0;
    if (openBalance1 > openBalance2) return -1;
    if (openBalance1 < openBalance2) return 1;
    // tie breaker 3: burn, a-z
    const urn1 = +BurnToken.parse(d1.urn).propertyValue;
    const urn2 = +BurnToken.parse(d2.urn).propertyValue;
    return urn1 < urn2 ? -1 : 1;
  });
}

export function updateSelectedDocumentList(
  updatedDocument: SessionDocumentInfo,
  selectedDocuments: SessionDocumentInfo[],
  discountData: AppliedDiscountMeta,
): SessionDocumentInfo[] {
  updatedDocument.overrideDiscount =
    discountData?.discountedPayableAmount != null &&
    updatedDocument.payableAmount > discountData.discountedPayableAmount &&
    updatedDocument.payableAmount <=
      updatedDocument.originalSessionPayableAmount;

  const updatedSelectedDocumentList: SessionDocumentInfo[] = selectedDocuments
    .filter((sessionDocument) => sessionDocument.urn !== updatedDocument.urn)
    .concat(updatedDocument);
  return updatedSelectedDocumentList;
}

export function updateModifiedDocumentsUrnList(
  modifiedDocument: ModifiedDocumentMeta,
  modifiedDocumentsUrnList: ModifiedDocumentMeta[],
): ModifiedDocumentMeta[] {
  return (modifiedDocumentsUrnList ?? [])
    .filter((x) => x.urn !== modifiedDocument.urn)
    .concat(modifiedDocument);
}
